import React from 'react';
import PropTypes from 'prop-types';
import './style.sass';

import MainSearch from '../../containers/MainSearch/MainSearch';

const MainInfo = props => (
  <div className="main-info">
    <div className="container">
      <h1 className="bold main-color">{props.content.title}</h1>
      <div className="row">
        <div className="col-md-6" dangerouslySetInnerHTML={{ __html: props.content.leftBlock }} />
        <div className="col-md-6" dangerouslySetInnerHTML={{ __html: props.content.rightBlock }} />
      </div>
      <MainSearch />
    </div>
  </div>
);

MainInfo.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    leftBlock: PropTypes.string,
    rightBlock: PropTypes.string,
  }),
};

MainInfo.defaultProps = {
  content: {},
};

export default MainInfo;
